import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cereri-page" }
const _hoisted_2 = { class: "cereri-inner" }
const _hoisted_3 = { class: "hero" }
const _hoisted_4 = { class: "hero-actions" }
const _hoisted_5 = { class: "co-chip" }
const _hoisted_6 = { class: "co-val" }
const _hoisted_7 = { class: "co-lbl" }
const _hoisted_8 = { class: "sumar" }
const _hoisted_9 = { class: "sumar-val" }
const _hoisted_10 = { class: "sumar-lbl" }
const _hoisted_11 = { class: "grid-card" }
const _hoisted_12 = { class: "grid-head" }
const _hoisted_13 = { class: "perioada" }
const _hoisted_14 = { class: "zile-badge" }
const _hoisted_15 = { class: "stare-wrap" }
const _hoisted_16 = {
  key: 0,
  class: "asteapta-la"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxMasterDetail = _resolveComponent("DxMasterDetail")!
  const _component_FluxAprobare = _resolveComponent("FluxAprobare")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hero-txt" }, [
          _createElementVNode("div", { class: "hero-eyebrow" }, "PORTAL HR"),
          _createElementVNode("h1", { class: "hero-title" }, "Cererile mele de concediu"),
          _createElementVNode("p", { class: "hero-sub" }, "Istoricul cererilor tale, statusul și cine trebuie să le aprobe.")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-umbrella-beach", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.zileCO), 1),
            _createElementVNode("span", _hoisted_7, "zile CO " + _toDisplayString(_ctx.anCurent), 1)
          ]),
          _createVNode(_component_v_btn, {
            class: "btn-plan",
            variant: "outlined",
            "prepend-icon": "mdi-calendar-month",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'PortalPlanificareAnuala' })))
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Planificare concediu ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            class: "btn-nou",
            "prepend-icon": "mdi-plus",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'PortalCerereNoua' })))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Cerere nouă ", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sumar, (s) => {
          return (_openBlock(), _createElementBlock("div", {
            key: s.key,
            class: "sumar-card",
            style: _normalizeStyle({ '--c': s.color })
          }, [
            _createVNode(_component_v_icon, {
              color: s.color,
              size: "22",
              class: "sumar-ic"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(s.icon), 1)
              ]),
              _: 2
            }, 1032, ["color"]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(s.count), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(s.label), 1)
            ])
          ], 4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_v_icon, {
            size: "18",
            color: "#ff5722",
            class: "mr-2"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("mdi-format-list-bulleted", -1)
            ]))]),
            _: 1
          }),
          _cache[7] || (_cache[7] = _createElementVNode("span", null, "Toate cererile", -1)),
          _createVNode(_component_v_spacer),
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "grid-hint" }, "Click pe o cerere pentru fluxul de aprobare", -1))
        ]),
        _createVNode(_component_DxDataGrid, {
          "data-source": _ctx.cereri,
          "key-expr": "ID",
          "show-borders": false,
          "show-column-lines": false,
          "show-row-lines": true,
          "row-alternation-enabled": false,
          "hover-state-enabled": true,
          "no-data-text": _ctx.loading ? 'Se încarcă…' : 'Nu ai depus nicio cerere încă.'
        }, {
          perioadaCell: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_v_icon, {
                size: "16",
                color: "#ff5722",
                class: "mr-2"
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("mdi-calendar-range", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.fmt(data.data.DataInceput)) + " ", 1),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "arr" }, "→", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.fmt(data.data.DataSfarsit)), 1)
              ])
            ])
          ]),
          zileCell: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_14, _toDisplayString(data.data.NumarZile), 1)
          ]),
          stareCell: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", {
                class: "stare-pill",
                style: _normalizeStyle(_ctx.starePillStyle(data.data.Stare))
              }, [
                _createElementVNode("span", {
                  class: "dot",
                  style: _normalizeStyle({ background: _ctx.stareColor(data.data.Stare) })
                }, null, 4),
                _createTextVNode(" " + _toDisplayString(_ctx.stareLabel(data.data.Stare)), 1)
              ], 4),
              (data.data.AsteaptaAprobareDeLa)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                    _createVNode(_component_v_icon, { size: "12" }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("mdi-arrow-right-thin", -1)
                      ]))]),
                      _: 1
                    }),
                    _createTextVNode(_toDisplayString(data.data.AsteaptaAprobareDeLa), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          actiuniCell: _withCtx(({ data }) => [
            (['0', '-3'].includes(data.data.Stare))
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  icon: "mdi-close-circle-outline",
                  size: "small",
                  color: "red",
                  variant: "text",
                  onClick: ($event: any) => (_ctx.anuleaza(data.data.ID)),
                  title: "Anulează cererea"
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          fluxTemplate: _withCtx(({ data }) => [
            _createVNode(_component_FluxAprobare, {
              id: data.data.ID
            }, null, 8, ["id"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DxColumn, {
              "data-field": "DataInceput",
              caption: "Perioadă",
              "data-type": "date",
              width: 220,
              "cell-template": "perioadaCell",
              "allow-filtering": false
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "NumarZile",
              caption: "Zile",
              width: 80,
              alignment: "center",
              "cell-template": "zileCell"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "TipConcediu",
              caption: "Tip concediu",
              "min-width": 150
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "Descriere",
              caption: "Observații",
              "min-width": 180
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "Stare",
              caption: "Stare",
              width: 240,
              "cell-template": "stareCell"
            }),
            _createVNode(_component_DxColumn, {
              caption: "",
              width: 56,
              "allow-filtering": false,
              "allow-sorting": false,
              "cell-template": "actiuniCell"
            }),
            _createVNode(_component_DxMasterDetail, {
              enabled: true,
              template: "fluxTemplate"
            }),
            _createVNode(_component_DxPaging, { "page-size": 12 }),
            _createVNode(_component_DxSorting, { mode: "single" }),
            _createVNode(_component_DxFilterRow, { visible: true })
          ]),
          _: 1
        }, 8, ["data-source", "no-data-text"])
      ])
    ])
  ]))
}